import { Camelized, decamelizeKeys } from "humps";
import merge from "lodash/merge";
import omit from "lodash/omit";
import pick from "lodash/pick";
import { camelizeApiKeys } from "PFCore/api/utils";

// TODO: [PROF-5746] Remove decamelizeKeys when app is camelized
export const decamelizeDesiredKeys = <T extends Record<string, any>>(
  object: T,
  keysToDecamelize: string[]
): T => merge(omit(object, keysToDecamelize), decamelizeKeys(pick(object, keysToDecamelize))) as T;

export const decamelizeKeysExcept = <T extends Record<string, any>>(object: T, except: string[]): T =>
  merge(pick(object, except), decamelizeKeys(omit(object, except))) as T;

export const camelizeDesiredKeys = <
  T extends Record<string, any>,
  KEYS extends (keyof T)[],
  U = Omit<T, KEYS[number]> & Camelized<Pick<T, KEYS[number]>>
>(
  object: T,
  keysToCamelize: KEYS
): U => merge(omit(object, keysToCamelize), camelizeApiKeys(pick(object, keysToCamelize))) as unknown as U;
